<template>
  <div sso-layout>
    <template v-if="!app">
      <div><Spinner /></div>
    </template>

    <template v-else>
      <h1
        v-if="app"
        v-html="app.name"
      />
      <h2 v-html="header" />
      <Dialog class="dialog">
        <div class="header">
          <h1 v-html="title" />
          <p><slot name="desc" /></p>
        </div>
        <div class="content">
          <slot />
        </div>
      </Dialog>
    </template>
    <div class="footer">
      Created by
      <a
        class="link"
        href="https://seenthis.se"
      >
        SeenThis
      </a>
      <img
        src="/face.gif"
        class="face"
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
  import Spinner from '../../components/spinner.vue';
  import Dialog from '../../components/dialog.vue';

  export default {
    name: 'SSO',
    components: {
      Spinner,
      Dialog,
    },
    props: [
      'app',
      'header',
      'title',
    ],
  };
</script>

<style scoped lang="stylus">
  @require '~@/style/colors'
  @require '~@/style/type'

  [sso-layout]
    min-height: 100vh
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    & > h1
      @extend $type-heading, $type-mega
      color: var(--color-primary)
    & > h2
      @extend $type-mini, $type-semibold
      letter-spacing: 0.2em
      text-transform: uppercase
      opacity: .4
      margin-top: 20px

  .dialog
    flex-shrink: 0
    margin-top: 50px
    max-width: 560px
    width: 100vw

  .header
    text-align: center
    padding: 50px 40px

    h1
      @extend $type-ultra

    p
      @extend $type-small
      margin-top: 1em
      line-height: 1.5em
      color: gray(8)

  .content
    background: linear-gradient(var(--color-foreground), gray(20), gray(20));
    padding: 40px

  .footer
    @extend $type-mini
    color: #666
    margin-top: 60px
    padding-bottom: 20px
    text-align: center

  .face
    display: block
    width: 12px
    height: 12px
    margin: 20px auto 0 auto
</style>
